import { useCallback, useState } from 'react';

export function useDisclosure(defaultIsOpen = false) {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  const onOpen = useCallback(() => setIsOpen(true), []);
  const onClose = useCallback(() => setIsOpen(false), []);
  const onToggle = useCallback(() => setIsOpen((value) => !value), []);

  return {
    isOpen,
    onOpen,
    onClose,
    onToggle,
    isControlled: false,
    getDisclosureProps: () => ({}),
    getButtonProps: () => ({})
  };
}
